import SPIRALTechDemo from "./SPIRALTechDemo";

export default SPIRALTechDemo;
